import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentView } from 'entities/tour/models/document'

import { Button } from 'shared/ui/button'

import common from '../../styles.module.scss'

import s from './styles.module.scss'

interface Props {
  onOpenAll: () => void
  document: TourDocumentView
}

export const TouristsCard: FC<Props> = ({ document, onOpenAll }) => {
  const { t } = useTranslation()

  if (!document.passengers.length) return null

  return (
    <section className={common.card}>
      <div>
        <h2 className="bold-16">{t('tourDetails.tourists')}</h2>
        <p className={clsx(common.caption, 'regular-14')}>
          {t('tourDetails.count', { count: document.passengers.length })}
        </p>
      </div>
      <div className={s.grid}>
        {document.passengers.slice(0, 3).map((passenger, index) => (
          <div
            className={s.tourist}
            key={passenger.id}
          >
            <p
              className={clsx(s.name, 'semi-bold-14')}
              title={passenger.fullName}
            >
              {passenger.fullName}
            </p>
            <p className={clsx(s.role, 'medium-12')}>
              {t(
                passenger.isCurrentUser
                  ? 'tourDetails.you'
                  : passenger.isCustomer
                    ? 'tourDetails.customer'
                    : 'tourDetails.participant',
                { number: index + 1 },
              )}
            </p>
          </div>
        ))}
        {document.passengers.length > 3 && (
          <Button
            variant="transparent"
            borderRadius="sm"
            className={clsx(s.all, 'semi-bold-14')}
            onClick={onOpenAll}
          >
            {t('tourDetails.allTourists', {
              count: document.passengers.length,
            })}
          </Button>
        )}
      </div>
    </section>
  )
}
